import React from "react"

import ComponentFactory from "../components/parsers/ComponentFactory"

import * as threeBannerSectionStyles from "../styles/ThreeBannerSection.module.css"

import WPCta from "./_base/WPCta"

function ThreeBannerSection(props) {
  const { content, pageContext } = props

  const titleNode = content.childNodes.filter(
    node => node.classNames === "three-banner-section-title"
  )[0]
  const title = (titleNode && titleNode.innerHTML) || ""


  const cards = content.childNodes
    .filter(node => node.classNames.trim().split(/\s+/).includes("banner-card"))
    .map(card => {
      const cardTitleNode = card.childNodes.filter(
        node => node.classNames === "banner-title"
      )[0]
      const cardTitle = (cardTitleNode && cardTitleNode.innerHTML) || ""

      const cardSubtitleNode = card.childNodes.filter(
        node => node.classNames === "banner-subtitle"
      )[0]
      const cardSubtitle =
        (cardSubtitleNode && cardSubtitleNode.innerHTML) || ""

      const contentNode = card.childNodes.filter(
        node => node.classNames === "banner-content"
      )[0]
      const cardContent = (contentNode && contentNode.innerHTML) || ""

      return { cardTitle, cardSubtitle, cardContent, cardCtaHolder: card}
    })

  return (
    <div className={`row  ${props.className} ${threeBannerSectionStyles.wrapper}`}>
      <div className={`col-12`}>
        <div className={`row ${threeBannerSectionStyles.bannerSectionTitle}`}>
          <div className={`col-12`}>
            <h2>{title}</h2>
          </div>
        </div>
        <div className={`row ${threeBannerSectionStyles.bannerCardsWrapper}`}>
          <div className={`col-3 ${threeBannerSectionStyles.bannerCards}`}>
            <h3>{cards[0].cardTitle}</h3>
            <h4>{cards[0].cardSubtitle}</h4>
            <div
              className={`${threeBannerSectionStyles.content}`}
              dangerouslySetInnerHTML={{
                __html: cards[0].cardContent,
              }}
            />
            <div className={`col ${threeBannerSectionStyles.ctaWrapper}`}>
            <WPCta
                holder={cards[0].cardCtaHolder}
                selector={`banner-cta`}
                className={`${threeBannerSectionStyles.cta}`}
                pageContext={props.pageContext}
                modals={props.modals}
              />
            </div>
          </div>
          <div className={`col-3 ${threeBannerSectionStyles.bannerCards}`}>
            <h3>{cards[1].cardTitle}</h3>
            <h4>{cards[1].cardSubtitle}</h4>
            <div
              className={`${threeBannerSectionStyles.content}`}
              dangerouslySetInnerHTML={{
                __html: cards[1].cardContent,
              }}
            />
            <div className={`col ${threeBannerSectionStyles.ctaWrapper}`}>
            <WPCta
                holder={cards[1].cardCtaHolder}
                selector={`banner-cta`}
                className={`${threeBannerSectionStyles.cta}`}
                pageContext={props.pageContext}
                modals={props.modals}
              />
            </div>

          </div>
          <div className={`col-3 ${threeBannerSectionStyles.bannerCards}`}>
            <h3>{cards[2].cardTitle}</h3>
            <h4>{cards[2].cardSubtitle}</h4>
            <div
              className={`${threeBannerSectionStyles.content}`}
              dangerouslySetInnerHTML={{
                __html: cards[2].cardContent,
              }}
            />
            <div className={`col ${threeBannerSectionStyles.ctaWrapper}`}>
            <WPCta
                holder={cards[2].cardCtaHolder}
                selector={`banner-cta`}
                className={`${threeBannerSectionStyles.cta}`}
                pageContext={props.pageContext}
                modals={props.modals}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ThreeBannerSection
